import { enhancedTripCardClickAction } from "../../../Actions/LogicActions/CMSEnhancedTrips/EnhancedTripCardClickAction";
import { getCMSEnhancedTripsAction } from "../../../Actions/LogicActions/CMSEnhancedTrips/GetCMSEnhancedTripsAction";
import { _eventBus } from "../../../core/events/EventBus";
import { StepDefinition } from "../../../core/flows/StepDefinition";
import { StepFlow } from "../../../core/flows/StepFlow";
import { evtTree } from "../../../Orchestrator/ConstantTree";
import { IGetEnhancedTripActionParams } from "../../../Orchestrator/Types/Interface/ICmsEnhancedTrip";
import { isWidgetEnabled } from "../../../Lib/Utils/isWidgetEnabled";

export class EnhancedTripsStep extends StepFlow {
    get stepName() { return "EnhancedTripsStep"; }

    async onEventSetup(): Promise<void> {
        this.registerEventSubscription(
            _eventBus.on({
                eventName: evtTree.enhancedTrips.Get,
                handler: async () => {
                    if (!isWidgetEnabled("enhanceYourTrip")) return;
                    getCMSEnhancedTripsAction.execute();
                }
            })
        );

        this.registerEventSubscription(
            _eventBus.on<IGetEnhancedTripActionParams, void>({
                eventName: evtTree.enhancedTrips.Details.Click,
                handler: async (data) => {
                    enhancedTripCardClickAction.setParams(data.data!);
                    await enhancedTripCardClickAction.execute();
                },
            })
        );
    }

    async onExecute(): Promise<void> {
        console.log("EnhancedTripsStep Init Step Execute...");

        this.eventBus.emit({
            eventName: evtTree.enhancedTrips.Get,
        });
    }
}
export const enhancedTripsStepDeclaration = new StepDefinition({
    stepName: "EnhancedTripsStep",
    stepClass: EnhancedTripsStep
});
